export class Constants {
	MONTHLY = 'M';
	YEARLY = 'Y';
}

export namespace Constants {
	export enum ReportingTimePeriodEnum {
		Monthly = 3,
		Yearly = 12
	}
}
